'use strict';

var MOVED_GENERAL_KEYS = [
    'maxSlides',
    'infinite',
    'commentOverflowBehavior',
];

function hasOwn(value, key) {
    return value && Object.prototype.hasOwnProperty.call(value, key);
}

function scheduleFormDirty(options) {
    if (!options || typeof options.$timeout !== 'function' || typeof options.getForm !== 'function') {
        return;
    }

    options.$timeout(function () {
        var form = options.getForm();
        if (form && typeof form.$setDirty === 'function') {
            form.$setDirty();
        }
    });
}

function migrateAchieversDataSettings(app, options) {
    if (!app || !app.appTemplate || app.appTemplate.slug !== 'achievers') {
        return app;
    }

    var general = app.settings && app.settings.general;
    if (!general) {
        return app;
    }

    app.data = app.data || {};
    var migrated = false;
    MOVED_GENERAL_KEYS.forEach(function (key) {
        if (!hasOwn(app.data, key) && hasOwn(general, key)) {
            app.data[key] = general[key];
            migrated = true;
        }
    });

    if (migrated) {
        scheduleFormDirty(options);
    }

    return app;
}

var achieversSettingsMigration = {
    migrateAchieversDataSettings: migrateAchieversDataSettings,
};

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = achieversSettingsMigration;
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value(
        'achieversSettingsMigration',
        achieversSettingsMigration,
    );
}
